/**
 * Shop The Look — Custom Element
 * Handles hotspot popup open/close, click-outside, and escape-key behavior.
 * Registered once; supports multiple instances on the same page.
 */
class ShopTheLookElement extends HTMLElement {
  constructor() {
    super();
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._onDocumentKeydown = this._onDocumentKeydown.bind(this);
    this._onResize = this.adjustCardHeights.bind(this);
  }

  connectedCallback() {
    this.hotspots = this.querySelectorAll('.shop-look__hotspot');
    this.setupHotspotEvents();
    this.adjustCardHeights();

    document.addEventListener('click', this._onDocumentClick);
    document.addEventListener('keydown', this._onDocumentKeydown);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocumentClick);
    document.removeEventListener('keydown', this._onDocumentKeydown);
    window.removeEventListener('resize', this._onResize);
  }

  setupHotspotEvents() {
    this.hotspots.forEach((hotspot) => {
      const button = hotspot.querySelector('.shop-look__hotspot-button');
      const popup = hotspot.querySelector('.shop-look__popup');
      const closeButton = popup.querySelector('.shop-look__popup-close');

      button.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeAllPopups();
        const isActive = popup.classList.contains('active');
        if (!isActive) {
          popup.classList.add('active');
          hotspot.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      });

      closeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        popup.classList.remove('active');
        hotspot.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      });
    });
  }

  closeAllPopups() {
    this.querySelectorAll('.shop-look__popup').forEach((popup) => {
      popup.classList.remove('active');
      const hotspot = popup.closest('.shop-look__hotspot');
      if (hotspot) {
        hotspot.classList.remove('active');
        const button = hotspot.querySelector('.shop-look__hotspot-button');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  adjustCardHeights() {
    const cards = this.querySelectorAll('.shop-look__product-card');
    if (cards.length > 0) {
      cards.forEach((card) => {
        card.style.minHeight = '';
      });
    }
  }

  _onDocumentClick(e) {
    const clickedHotspot = e.target.closest('.shop-look__hotspot');
    if (!clickedHotspot || !this.contains(clickedHotspot)) {
      this.closeAllPopups();
    }
  }

  _onDocumentKeydown(e) {
    if (e.key === 'Escape') {
      this.closeAllPopups();
    }
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLookElement);
}